<template>
  <div class="hello">
		<button v-on:click="download">立即下载</button>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      isAndroid:false,
			isIos:false,
			isWeixin:false,
			schemeUrl:'',
      downloadUrl:'',
    }
  },

	created() {

		var u = navigator.userAgent,
		app = navigator.appVersion;

		var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
		var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
		if(isAndroid){

			this.isAndroid = true;
			// this.schemeUrl = 'guoss://app/openwith'; //安卓的SchemeUrl
			// this.downloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zhangshuo.gss'; //安卓的下载地址
			this.schemeUrl = 'grhao://app/openwith'; //安卓的SchemeUrl
			this.downloadUrl = 'https://sj.qq.com/myapp/detail.htm?apkName=com.zsinfo.guoranhao&info=8CCA38E04E21C765D1258C1CA400B9C7'; //安卓的下载地址
		}

		if(isIOS){

			this.isIos = true;
			this.schemeUrl = 'grhao://'; //iOS的SchemeUrl
			this.downloadUrl = 'https://apps.apple.com/us/app/果然好生鲜商城/id1231269876'; //iOS下载地址
		}

		if(isWeixin) {

			this.isWeixin = ture;
			alert('请在浏览器上打开');
		}
	},

	methods:{

		download:function(){

			// 微信内
      if(this.isWeixin) {
          alert('请在浏览器上打开')
       } else {
      //android端
      if (this.isAndroid) {
        //安卓app的scheme协议
        window.location.href = this.schemeUrl;
        setTimeout(function(){
        let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
        if(typeof hidden =="undefined" || hidden ==false){
            //应用宝下载地址 (emmm 找不到淘宝应用宝的地址，这里放的是 lucky coffee 地址)
            window.location.href = this.downloadUrl;
        }
         }.bind(this), 2000);
        }
      //ios端
      if (this.isIos) {

        //ios的scheme协议
        window.location.href = this.schemeUrl

        setTimeout(function(){
            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden
						if(typeof hidden == "undefined" || hidden == false){
              //App store下载地址
              window.location.href = this.downloadUrl;
            }
          }.bind(this), 2000);
        }
      }
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {

	background-color: rgb(0,125,255);
	color: white;
	width: 120px;
	height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue